;(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';

	var Collection 	= APP.module('Collection');
	var Model 		= APP.module('Model');

	Collection.Venues = Backbone.Collection.extend({
		model: Model.Squad,
		url: 'venues.json'
	});

}(window, APP, Backbone, Marionette, $, _));